import React, { useState, useEffect } from "react";

const Brochure = () => {
    const pages = [
        '/img/brochure/page_1.png',
        '/img/brochure/page_2.png',
        '/img/brochure/page_3.png',
        '/img/brochure/page_4.png',
        '/img/brochure/page_5.png',
        '/img/brochure/page_6.png',
        '/img/brochure/page_7.png',
    ];

    const [currentPage, setCurrentPage] = useState(0);
    const [isChanging, setIsChanging] = useState(false);

    const changePage = (newPage) => {
        if (newPage >= 0 && newPage < pages.length && newPage !== currentPage) {
            setIsChanging(true);
            // Small delay to allow the fade-out animation to complete
            setTimeout(() => {
                setCurrentPage(newPage);
                setIsChanging(false);
            }, 200);
        }
    };

    const nextPage = () => changePage(currentPage + 1);
    const prevPage = () => changePage(currentPage - 1);

    const [showModal, setShowModal] = useState(false);

    const handleImageClick = () => setShowModal(true);
    const handleCloseModal = (e) => {
        if (e.target.classList.contains('brochure-modal') || e.target.classList.contains('close-modal')) {
            setShowModal(false);
        }
    };

    return (
        <section id="brochure" className="bg-light py-5">
            <div className="container text-center">
                <h2 className="h3 mb-4">Unser Angebot</h2>
                <div 
                    className="d-flex justify-content-center"
                    style={{
                        minHeight: '400px',
                        alignItems: 'center',
                        transition: 'opacity 0.2s ease-in-out',
                        opacity: isChanging ? 0 : 1
                    }}
                >
                    <img 
                        src={pages[currentPage]} 
                        alt={`Seite ${currentPage + 1}`} 
                        className="img-fluid rounded shadow mb-3 brochure-zoom-cursor" 
                        style={{ 
                            maxWidth: '60%', 
                            height: 'auto',
                            transition: 'transform 0.2s',
                            cursor: 'zoom-in'
                        }}
                        onClick={handleImageClick}
                        onMouseOver={e => e.currentTarget.style.transform = 'scale(1.01)'}
                        onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
                    />
                </div>
                {showModal && (
                    <div className="brochure-modal" onClick={handleCloseModal} style={{
                        position: 'fixed', zIndex: 1050, left: 0, top: 0, width: '100vw', height: '100vh', background: 'rgba(24,24,28,0.88)', display: 'flex', alignItems: 'center', justifyContent: 'center', transition: 'opacity 0.2s', cursor: 'zoom-out'
                    }}>
                        <div style={{position: 'relative', maxWidth: '96vw', maxHeight: '92vh', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <button className="close-modal btn btn-light btn-sm" style={{position: 'absolute', top: 10, right: 10, zIndex: 2, borderRadius: '50%', width: 36, height: 36, fontSize: 20, fontWeight: 700, opacity: 0.85}} aria-label="Schließen">×</button>
                            <img src={pages[currentPage]} alt={`Seite ${currentPage + 1}`} style={{maxWidth: '95vw', maxHeight: '80vh', borderRadius: '0.75rem', boxShadow: '0 4px 32px 0 rgba(0,0,0,0.18)'}} />
                            <div className="btn-group mt-3 mb-2">
                                <button onClick={prevPage} className="btn btn-outline-light" disabled={currentPage === 0 || isChanging} style={{fontWeight: 500, opacity: currentPage === 0 ? 0.7 : 1}}>← Zurück</button>
                                <button onClick={nextPage} className="btn btn-outline-light" disabled={currentPage === pages.length - 1 || isChanging} style={{fontWeight: 500, opacity: currentPage === pages.length - 1 ? 0.7 : 1}}>Weiter →</button>
                            </div>
                            <p className="text-light" style={{fontSize: '1rem'}} >Seite {currentPage + 1} von {pages.length}</p>
                        </div>
                    </div>
                )}

                <div className="btn-group mb-2">
                    <button 
                        onClick={prevPage} 
                        className="btn btn-outline-secondary"
                        disabled={currentPage === 0 || isChanging}
                        style={{
                            transition: 'all 0.2s',
                            transform: currentPage === 0 ? 'scale(0.95)' : 'scale(1)'
                        }}
                    >
                        ← Zurück
                    </button>
                    <button 
                        onClick={nextPage} 
                        className="btn btn-outline-primary"
                        disabled={currentPage === pages.length - 1 || isChanging}
                        style={{
                            transition: 'all 0.2s',
                            transform: currentPage === pages.length - 1 ? 'scale(0.95)' : 'scale(1)'
                        }}
                    >
                        Weiter →
                    </button>
                </div>
                <p className="text-muted">Seite {currentPage + 1} von {pages.length}</p>
            </div>
        </section>
    );
}

export default Brochure;


// WEBPACK FOOTER //
// ./src/components/Brochure.js